import { DropinElementProps } from '@adyen/adyen-web/dist/types/components/Dropin/types'
import { OnPaymentCompletedData } from '@adyen/adyen-web/dist/types/components/types'
import AdyenCheckoutError from '@adyen/adyen-web/dist/types/core/Errors/AdyenCheckoutError'
import { CustomTranslations } from '@adyen/adyen-web/dist/types/language/types'
import { captureException } from '@sentry/react'
import createAdyenCheckout from './createAdyenCheckout.utils'

const createAdyenDropin = async (
    session: { [key: string]: string },
    onCompleted: (code: OnPaymentCompletedData) => void,
    onError: (error: AdyenCheckoutError) => void,
    translations?: CustomTranslations,
    dropInOptions?: DropinElementProps
) => {
    try {
        const checkout = await createAdyenCheckout(session, onCompleted, onError, translations)

        const dropin = checkout.create('dropin', dropInOptions)

        return { checkout, dropin }
    } catch (e) {
        captureException(`Error on Adyen Dropin: ${e}`)
        if (e instanceof Error) return e.message

        return 'Something went wrong'
    }
}

export default createAdyenDropin
